export default __webpack_public_path__ + "static/media/Bolo-De-Berlim-Nutella.abe8397c.jpg";